import React from 'react'
import FiltrosAdicionadosEncomenda from './FiltrosAdicionadosEncomenda'
import Filtro from '../comum/Filtro'
import FiltroEncomenda from './FiltroEncomenda'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroEncomendas = () => (
  <Filtro PainelFiltro={FiltroEncomenda}/>
);

const PainelFiltrosEncomendas = () => (
  <PainelFiltragem
    Filtro={PainelFiltroEncomendas}
    FiltrosAdicionados={FiltrosAdicionadosEncomenda}/>
)

export default PainelFiltrosEncomendas
